var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"small",style:('width:100%;height:'+_vm.bannerHeight+'px;'),attrs:{"src":_vm.src,"frameborder":"no"},on:{"load":_vm.vrLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }